module.exports = __webpack_public_path__ + "static/media/Свидетельство о государственной регистрации юридического лица (МКК Капелла).a57e376f.jpg";